u.CarouselNav = class extends u.ForElement {
    /**
     *
     */
    createdCallback() {
        /**
         *
         */
        super.createdCallback();
        this.isHighlightActive = this.getAttribute('highlight') === 'true';

    }

    attachedCallback() {
        /**
         *
         */
        super.attachedCallback();

        if (this.isHighlightActive) {
            this.$forElement.addEventListener('move', (evt) => {
                if (parseInt(this.toIndex) === evt.detail.index) {
                    this.classList.add('active');
                } else {
                    this.classList.remove('active');
                }
            });
        }
    }
};

u.CarouselNav.register('u-carousel-nav');